import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';


  
  export const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
      setTasks:(state, action) => {
        state.tasksData = action.payload
      }
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const { setTasks } = tasksSlice.actions
  
  export default tasksSlice.reducer